import { graphql } from "@opensea/graphql"
import { CollectionItemsMakeOfferButtonFragment } from "./CollectionItemsMakeOfferButton.fragment"

export const CollectionItemsBuyActionsFragment = graphql(
  `
    fragment CollectionItemsBuyActions on Collection {
      slug
      ...CollectionItemsMakeOfferButton
    }
  `,
  [CollectionItemsMakeOfferButtonFragment],
)
